import { useEffect, useRef } from 'react';
import i18n from 'i18next';

/**
 * «Έχει πρόχειρο κάποια βιβλιοθήκη;» — για την αλλαγή καρτέλας ΜΕΣΑ στη σελίδα «Κατάλογος».
 * Οι καρτέλες βιβλιοθηκών δηλώνονται και στο κοινό utils/unsavedChanges (έξοδος από τη σελίδα), αλλά
 * εκεί είναι και το πρόχειρο των προϊόντων, που ΔΕΝ χάνεται όταν αλλάζεις καρτέλα· εδώ μετράνε μόνο
 * οι βιβλιοθήκες, που χάνουν την ανοιχτή κάρτα όταν η καρτέλα κλείνει.
 */

const drafts = new Map<string, () => boolean>();

/** Η καρτέλα δηλώνει αν έχει αλλαγές που δεν αποθηκεύτηκαν (όσο είναι ανοιχτή). */
export function useLibraryDraftGuard(id: string, dirty: boolean): void {
  const ref = useRef(dirty);
  useEffect(() => { ref.current = dirty; }, [dirty]);
  useEffect(() => {
    const isDirty = () => ref.current;
    drafts.set(id, isDirty);
    return () => { if (drafts.get(id) === isDirty) drafts.delete(id); };
  }, [id]);
}

export const libraryHasDraft = (): boolean => Array.from(drafts.values()).some(isDirty => isDirty());

/** Πριν κλείσει η καρτέλα βιβλιοθήκης: true = μπορεί (καμία αλλαγή ή ο χρήστης δέχτηκε να χαθούν). */
export function confirmLeaveLibrary(): boolean {
  if (!libraryHasDraft()) return true;
  return window.confirm(i18n.t('settings:unsaved.confirmLeave'));
}
